module.exports = __webpack_public_path__ + "static/media/grade2.67ffe3a5.jpg";